module.exports = __webpack_public_path__ + "static/media/stupidFace.3224ea30.jpg";